import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './index.scss';

import { ReactComponent as IconClose } from '../../../../assets/images/close.svg';
import { ReactComponent as ExclamationIcon } from '../../../../assets/images/exclamation-info.svg';
import { ReactComponent as InfoIcon } from '../../../../assets/images/info.svg';
import { NoticeOrErrorModel } from '../../../../models/notice.error.model';
import { clearErrors, clearNotices, errors as errorsData, notices as noticesData } from '../../../../store/ui';
import Container from '../base/container';

interface IErrorContainer {
    classNameErrorContainer?: string;
    classNameNoticeContainer?: string;
    errors?: Record<string, unknown | string>;
    getDataFromRedux?: boolean;
    notices?: Record<string, unknown | string>;
}

type Props = IErrorContainer;

const ErrorContainer: FC<Props> = ({
    errors = {},
    notices = {},
    getDataFromRedux = true,
    classNameErrorContainer = '',
    classNameNoticeContainer = '',
}) => {
    const dispatch = useDispatch();
    const errorsState = useSelector(errorsData);
    const noticesState = useSelector(noticesData);
    const errorsList = Object.values(getDataFromRedux ? errorsState : errors);
    const noticesList = Object.values(getDataFromRedux ? noticesState : notices) as NoticeOrErrorModel[];

    const returnLeftPart = (message: string, action: ReturnType<typeof clearErrors> | ReturnType<typeof clearNotices>) => (
        <>
            <p>{message}</p>
            <div
                className={'closeErrorIcon'}
                onClick={e => {
                    e.stopPropagation();
                    dispatch(action);
                }}
            >
                <IconClose width={14} height={14} />
            </div>
        </>
    );

    if (errorsList.every(error => !error) && isEmpty(noticesList)) {
        return null;
    }

    return (
        <Container classNamesContainer={'error__container'}>
            {!isEmpty(errorsList) &&
                errorsList.map(error => {
                    const { code, message } = error as NoticeOrErrorModel;

                    if (!error || !errorsState[code]) {
                        return;
                    }

                    return (
                        <div
                            key={`error-container-${code}-${message}`}
                            className={classNames('errorContainer pointer', classNameErrorContainer)}
                        >
                            <ExclamationIcon width={20} height={20} />
                            {returnLeftPart(message, clearErrors(String(code)))}
                        </div>
                    );
                })}

            {!isEmpty(noticesList) &&
                noticesList.map(({ message, code }) => (
                    <div
                        key={`notice-container-${code}`}
                        className={classNames('errorContainer notices', classNameNoticeContainer)}
                    >
                        <InfoIcon width={20} height={20} />
                        {returnLeftPart(message, clearNotices(String(code)))}
                    </div>
                ))}
        </Container>
    );
};

export default ErrorContainer;
